// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogContent-space1-A_NRp {
	margin-bottom: 6px !important;
}

.BlogContent-space2-E7uQ6 {
	margin-bottom: 12px !important;
}

.BlogContent-space3-_Q5vX {
	margin-bottom: 18px !important;
}

.BlogContent-space4-U3kES {
	margin-bottom: 24px !important;
}

.BlogContent-space5-q340c {
	margin-bottom: 30px !important;
}

.BlogContent-space6-DFtuv {
	margin-bottom: 36px !important;
}

.BlogContent-space7-Prijg {
	margin-bottom: 42px !important;
}

.BlogContent-spaceTop8-YPNhq {
	margin-bottom: 48px !important;
}

.BlogContent-spaceTop1-O5GLI {
	margin-top: 6px !important;
}

.BlogContent-spaceTop2-JP2SV {
	margin-top: 12px !important;
}

.BlogContent-spaceTop3-YLAC4 {
	margin-top: 18px !important;
}

.BlogContent-spaceTop4-LvwH5 {
	margin-top: 24px !important;
}

.BlogContent-spaceTop5-G4n5N {
	margin-top: 30px !important;
}

.BlogContent-spaceTop6-DqJ0L {
	margin-top: 36px !important;
}

.BlogContent-spaceTop7-ZcNCz {
	margin-top: 42px !important;
}

.BlogContent-spaceTop8-YPNhq {
	margin-top: 48px !important;
}

.BlogContent-noMargin-UcM_j {
	margin: 0px !important;
}

.BlogContent-padding1-Ix5vr {
	padding-bottom: 6px !important;
}

.BlogContent-padding2-XuQiV {
	padding-bottom: 12px !important;
}

.BlogContent-padding3-kdBMq {
	padding-bottom: 18px !important;
}

.BlogContent-padding4-u1dh7 {
	padding-bottom: 24px !important;
}

.BlogContent-padding5-Boc3Z {
	padding-bottom: 30px !important;
}

.BlogContent-padding6-ebtao {
	padding-bottom: 36px !important;
}

.BlogContent-padding7-ugyog {
	padding-bottom: 42px !important;
}

.BlogContent-paddingTop1-ozpna {
	padding-top: 6px !important;
}

.BlogContent-paddingTop2-UZXzY {
	padding-top: 12px !important;
}

.BlogContent-paddingTop3-k4ev0 {
	padding-top: 18px !important;
}

.BlogContent-paddingTop4-ltCPb {
	padding-top: 24px !important;
}

.BlogContent-paddingTop5-HqCHe {
	padding-top: 30px !important;
}

.BlogContent-paddingTop6-XJipZ {
	padding-top: 36px !important;
}

.BlogContent-paddingTop7-WwD8_ {
	padding-top: 42px !important;
}

.BlogContent-noPadding-eale2 {
	padding: 0px !important;
}

.BlogContent-textBold-pZau2 {
	font-weight: 500 !important;
}

.BlogContent-textBolder-SNAKo {
	font-weight: 700 !important;
}

.BlogContent-textNormal-UjREg {
	font-weight: normal !important;
}

.BlogContent-spaceBottom20-cQG09 {
	margin-bottom: 20px;
}

.BlogContent-spaceBottom10-sbq0L {
	margin-bottom: 10px;
}

.BlogContent-marginNone-EmFuD {
	margin: 0;
}

.BlogContent-spaceBottom15-jWyCU {
	margin-bottom: 15px;
}

.BlogContent-marginTopNone-pguSd {
	margin-top: 0;
}

.BlogContent-spaceTop11-mv5bT {
	margin-top: 11px;
}

.BlogContent-spaceTop21-YRKxD {
	margin-top: 21px;
}

.BlogContent-spaceTop20-TAZSZ {
	margin-top: 20px;
}

.BlogContent-spaceTop10-_sxPM {
	margin-top: 10px;
}

/*New Design Text Colors */

.BlogContent-textDarkBlue-jO2al {
	color: rgb(20, 39, 94) !important;
}

.BlogContent-textLightBlue-O9H3d {
	color: rgb(57, 87, 106) !important;
}

.BlogContent-textLightSandleGreen-PbsQY {
	color: rgb(76, 86, 41) !important;
}

.BlogContent-textLightBrown-b1csw {
	color: rgb(115, 79, 33) !important;
}

.BlogContent-textMediumMaroon-hHqoe {
	color: rgb(87, 37, 51) !important;
}

.BlogContent-textBrown-IxU3p {
	color: rgb(160, 47, 24) !important;
}

.BlogContent-textMaroon-jMfD8 {
	color: rgb(155, 49, 67) !important;
}

.BlogContent-textDarkBrown-Hrs90 {
	color: rgb(83, 18, 16) !important;
}

.BlogContent-textMediumBrown-stjBp {
	color: rgb(142, 28, 10) !important;
}

.BlogContent-textSkyBlue-Rjkfy {
	color: rgb(37, 117, 141) !important;
}

.BlogContent-textGray-Gv09V {
	color: rgb(77, 65, 51) !important;
}

.BlogContent-subText-pF9Th {
	margin-top: 45px;
	font-size: 16px;
	color: var(var(--primary-foreground));
	text-align: justify;
	font-weight: 300;
	font-style: normal;
}

.BlogContent-root-Ts2dl {
	width: 100%;
	max-width: var(--max-content-width);
	margin: 0 auto;
	min-height: 50vh;
}

/** Banner caption - End **/

@media screen and (max-width:1200px) {
	.BlogContent-root-Ts2dl {
		padding-top: 45px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/BlogContent/BlogContent.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,gBAAgB;CAChB,eAAe;CACf,qCAAqC;CACrC,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,mCAAmC;CACnC,cAAc;CACd,gBAAgB;AACjB;;AAEA,2BAA2B;;AAC3B;CACC;EACC,iBAAiB;CAClB;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../helpers.css';\n\n.subText {\n\tmargin-top: 45px;\n\tfont-size: 16px;\n\tcolor: var(var(--primary-foreground));\n\ttext-align: justify;\n\tfont-weight: 300;\n\tfont-style: normal;\n}\n\n.root {\n\twidth: 100%;\n\tmax-width: var(--max-content-width);\n\tmargin: 0 auto;\n\tmin-height: 50vh;\n}\n\n/** Banner caption - End **/\n@media screen and (max-width:1200px) {\n\t.root {\n\t\tpadding-top: 45px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `BlogContent-space1-A_NRp`,
	"space2": `BlogContent-space2-E7uQ6`,
	"space3": `BlogContent-space3-_Q5vX`,
	"space4": `BlogContent-space4-U3kES`,
	"space5": `BlogContent-space5-q340c`,
	"space6": `BlogContent-space6-DFtuv`,
	"space7": `BlogContent-space7-Prijg`,
	"spaceTop8": `BlogContent-spaceTop8-YPNhq`,
	"spaceTop1": `BlogContent-spaceTop1-O5GLI`,
	"spaceTop2": `BlogContent-spaceTop2-JP2SV`,
	"spaceTop3": `BlogContent-spaceTop3-YLAC4`,
	"spaceTop4": `BlogContent-spaceTop4-LvwH5`,
	"spaceTop5": `BlogContent-spaceTop5-G4n5N`,
	"spaceTop6": `BlogContent-spaceTop6-DqJ0L`,
	"spaceTop7": `BlogContent-spaceTop7-ZcNCz`,
	"noMargin": `BlogContent-noMargin-UcM_j`,
	"padding1": `BlogContent-padding1-Ix5vr`,
	"padding2": `BlogContent-padding2-XuQiV`,
	"padding3": `BlogContent-padding3-kdBMq`,
	"padding4": `BlogContent-padding4-u1dh7`,
	"padding5": `BlogContent-padding5-Boc3Z`,
	"padding6": `BlogContent-padding6-ebtao`,
	"padding7": `BlogContent-padding7-ugyog`,
	"paddingTop1": `BlogContent-paddingTop1-ozpna`,
	"paddingTop2": `BlogContent-paddingTop2-UZXzY`,
	"paddingTop3": `BlogContent-paddingTop3-k4ev0`,
	"paddingTop4": `BlogContent-paddingTop4-ltCPb`,
	"paddingTop5": `BlogContent-paddingTop5-HqCHe`,
	"paddingTop6": `BlogContent-paddingTop6-XJipZ`,
	"paddingTop7": `BlogContent-paddingTop7-WwD8_`,
	"noPadding": `BlogContent-noPadding-eale2`,
	"textBold": `BlogContent-textBold-pZau2`,
	"textBolder": `BlogContent-textBolder-SNAKo`,
	"textNormal": `BlogContent-textNormal-UjREg`,
	"spaceBottom20": `BlogContent-spaceBottom20-cQG09`,
	"spaceBottom10": `BlogContent-spaceBottom10-sbq0L`,
	"marginNone": `BlogContent-marginNone-EmFuD`,
	"spaceBottom15": `BlogContent-spaceBottom15-jWyCU`,
	"marginTopNone": `BlogContent-marginTopNone-pguSd`,
	"spaceTop11": `BlogContent-spaceTop11-mv5bT`,
	"spaceTop21": `BlogContent-spaceTop21-YRKxD`,
	"spaceTop20": `BlogContent-spaceTop20-TAZSZ`,
	"spaceTop10": `BlogContent-spaceTop10-_sxPM`,
	"textDarkBlue": `BlogContent-textDarkBlue-jO2al`,
	"textLightBlue": `BlogContent-textLightBlue-O9H3d`,
	"textLightSandleGreen": `BlogContent-textLightSandleGreen-PbsQY`,
	"textLightBrown": `BlogContent-textLightBrown-b1csw`,
	"textMediumMaroon": `BlogContent-textMediumMaroon-hHqoe`,
	"textBrown": `BlogContent-textBrown-IxU3p`,
	"textMaroon": `BlogContent-textMaroon-jMfD8`,
	"textDarkBrown": `BlogContent-textDarkBrown-Hrs90`,
	"textMediumBrown": `BlogContent-textMediumBrown-stjBp`,
	"textSkyBlue": `BlogContent-textSkyBlue-Rjkfy`,
	"textGray": `BlogContent-textGray-Gv09V`,
	"subText": `BlogContent-subText-pF9Th`,
	"root": `BlogContent-root-Ts2dl`
};
module.exports = ___CSS_LOADER_EXPORT___;
